import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from '../../../environments/environment';
import { TenantListResponse, CreateTenantResponse, TenantDetail } from '../interfaces';

const baseUrl = `${environment.apiUrl}/admin`;

@Injectable({
  providedIn: 'root',
})
export class TenantService {
  private http = inject(HttpClient);

  getTenants(page: number = 1, pageSize: number = 10): Observable<TenantListResponse> {
    return this.http.get<TenantListResponse>(`${baseUrl}/tenants`, {
      params: { page, page_size: pageSize },
    });
  }

  getTenant(id: string): Observable<TenantDetail> {
    return this.http.get<TenantDetail>(`${baseUrl}/tenants/${encodeURIComponent(id)}`);
  }

  getTenantLogoUrl(id: string): Observable<string | null> {
    return this.getTenant(id).pipe(map(t => this.resolveLogoUrl(t.logo_url)));
  }

  createTenant(formData: FormData): Observable<CreateTenantResponse> {
    return this.http.post<CreateTenantResponse>(`${baseUrl}/tenants`, formData);
  }

  private resolveLogoUrl(url: string | null): string | null {
    if (!url) return null;
    if (url.startsWith('gs://')) {
      return url.replace('gs://', 'https://storage.googleapis.com/');
    }
    return url;
  }
}
